import { render, staticRenderFns } from "./DialogReferSupplier.vue?vue&type=template&id=3a95a550&"
import script from "./DialogReferSupplier.vue?vue&type=script&lang=js&"
export * from "./DialogReferSupplier.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports